<template>
	<div id="dashboard"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view" v-else="" >
				<!--<side-nav-bar></side-nav-bar>-->
				<div class="app-container">
					<bar>
					</bar>
					<div style="text-align: center; margin-top: 10vh">
						<h1>Hola {{ user.nickname }} !</h1>
					</div>
					<div style="text-align: center; margin-top: 18vh">

							<h2 style="color:black;">Bonell+Dòriga</h2>
						</div>


				</div>
			</div>
		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'

    import { localStorageMixin } from '../../mixins'
    import Spinner from '../../components/Spinner.vue'
    import Search from '../../components/Search/Index.vue'
    import Editor from '../../components/Editor/Index.vue'
    import Bar from '../../components/Bar/Index.vue'
    import IconButton from '../../components/IconButton/Index.vue'
    import SideNavBar from '../../components/SideNavBar/Index.vue'

    import router from '../../router/index.js'

    export default {
        name: 'dashboard',

        mixins: [localStorageMixin],

        data: () => ({
            master_loading: true
        }),

        created () {
            const user = this.ls_pullUser()
            this.SET_USER(user)
            this.FETCH_USER_DATA()
                .then(() => {
                    this.FETCH_STATS_CURRENT()
                        .then(() => {
                            this.master_loading = false
                        })
                })
        },

        components: {
            Editor,
            Bar,
            Search,
            Spinner,
            IconButton,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'user_role',
				'stats_current',
				'user'
            ])
        },

        methods: {
            ...mapActions([
                'FETCH_USER_DATA',
				'FETCH_STATS_CURRENT'
            ]),
            ...mapMutations([
                'SET_USER'
            ]),
            checkAppBarPermissions () {
                return this.user_role !== 'guest'
            }
        },

        head: {
            title: {
                inner: 'App'
            }
        }

    }
</script>

<style>
	.fade-enter-active, .fade-leave-active {
		transition: opacity 1s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?49bbbea9